module.exports = __webpack_public_path__ + "media/theme/border-13-86443a01.png";